import moment from 'moment';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  Skeleton,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';

import '../../../scss/Components/_modal.scss';
import customAxios from '../../../utils/customAxios';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';

const ModalUUpdate = (props) => {
  const { notesString, jobString, techEntryDateString } = useTranslationHook();

  const weakPWErrorAlert = (missingRequirements) => {
    toast.dismiss();
    if (missingRequirements.length > 0) {
      toast.error(
        'La contraseña ingresada es débil. No cumple con los siguientes requisitos:',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );

      missingRequirements.forEach((requirement) => {
        toast.info(`${requirement}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  var updateUserId = localStorage.getItem('userIdToUpdate');
  const loggedUserId = localStorage.getItem('userIdForPerm');

  const [rolesData, setRolesData] = useState([]);

  useEffect(() => {
    customAxios
      .get(`${GlobalVariables.getURL()}autofillRolesUpdate`, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setRolesData(response.data);
      })

      .catch((error) => console.log(error));
  }, []);

  var emailDefaultU = localStorage.getItem('emailForUpdate');
  var nameDefaultU = localStorage.getItem('nameForUpdate');
  var lastNameDefaultU = localStorage.getItem('lastNameForUpdate');
  var roleIdDefaultU = localStorage.getItem('roleIdForUpdate');
  var roleNameDefaultU = localStorage.getItem('roleNameForUpdate');
  var jobDefaultU = localStorage.getItem('userJobForUpdate');
  var entryDateDefaultU = localStorage.getItem('userEntryDateForUpdate');
  var notesDefaultU = localStorage.getItem('userNotesForUpdate');
  var clientsDefaultU =
    localStorage.getItem('clientsForUpdate')?.split(',').map(Number) || [];

  const [email, setEmail] = useState(emailDefaultU);
  const [name, setName] = useState(nameDefaultU);
  const [lastName, setLastName] = useState(lastNameDefaultU);
  const [password, setPW] = useState('');
  const [verifyPassword, setVPW] = useState('');
  const [changeReason, setChangeReason] = useState('');
  const [job, setJob] = useState(jobDefaultU);
  const [entryDate, setEntryDate] = useState(moment(entryDateDefaultU));
  const [notes, setNotes] = useState(notesDefaultU);
  const [role, setRole] = useState(roleIdDefaultU);
  const [selectedRole, setSelectedRole] = useState(null);
  const [roleName, setRoleName] = useState(roleNameDefaultU);
  const [clients, setClients] = useState(clientsDefaultU);
  const [selectedClients, setSelectedClients] = useState([]);
  console.log(selectedClients);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (props.show) {
      fetchClients();
      fetchRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const fetchClients = async () => {
    setIsFetching(true);
    try {
      const endpoint = `${GlobalVariables.getURL()}listAutocompleteClients?targetUserId=${updateUserId}`;
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 204) {
        setClients([]);
        setSelectedClients([]);
        return;
      }

      const allClients = response.data;
      setClients(allClients);

      const selected = allClients.filter((client) =>
        clientsDefaultU.includes(client.id)
      );
      setSelectedClients(selected);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchRoles = async () => {
    try {
      const response = await customAxios.get(
        `${GlobalVariables.getURL()}autofillRoles`,
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );
      setRolesData(response.data);

      const defaultRole = response.data.find(
        (role) => role.id === parseInt(roleIdDefaultU)
      );

      setSelectedRole(defaultRole || null);
    } catch (error) {
      console.log(error);
      getToast({
        status: 'error',
        title: 'Error al cargar roles',
      });
    }
  };

  const resetFormFields = () => {
    setEmail(localStorage.getItem('emailForUpdate'));
    setName(localStorage.getItem('nameForUpdate'));
    setLastName(localStorage.getItem('lastNameForUpdate'));
    setRole(localStorage.getItem('roleIdForUpdate'));
    setRoleName(localStorage.getItem('roleNameForUpdate'));
    setPW('');
    setVPW('');
    setChangeReason('');
    setJob(localStorage.getItem('userJobForUpdate'));
    setEntryDate(moment(localStorage.getItem('userEntryDateForUpdate')));
    setNotes(localStorage.getItem('userNotesForUpdate'));
  };

  const hide = () => {
    props.onHide();
    toast.dismiss();
    getToast({
      status: 'success',
      title: 'Usuario actualizado exitosamente en la base de datos.',
    });
    props.getUsers();
  };

  const updateUser = (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (password === verifyPassword) {
      const data = {
        name: name,
        last_names: lastName,
        email: email,
        password: password,
        job,
        entry_date: entryDate.toISOString(),
        notes,
        roles_id: role,
        clients: selectedClients.map((client) => client.id),
        regions: [],
      };

      customAxios
        .patch(`${GlobalVariables.getURL()}update/${updateUserId}`, data, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then(
          (response) => {
            hide();
          },
          (error) => {
            console.log(error);
            if (error.response.data === 'Usuario ya existe.') {
              toast.dismiss();
              getToast({
                status: 'error',
                title:
                  'Ya existe un usuario con esta información. Vuelve a intentarlo.',
              });
            } else if (error.response.data.startsWith('Contraseña débil.')) {
              const requirements = [
                'Debe contener al menos una letra mayúscula.',
                'Debe contener al menos un número.',
                'Debe contener al menos un caracter especial (!@#$%^&*).',
                'Debe tener al menos 9 caracteres de longitud.',
              ];

              const missingRequirements = requirements.filter((requirement) =>
                error.response.data.includes(requirement)
              );

              weakPWErrorAlert(missingRequirements);
            } else {
              toast.dismiss();
              getToast({
                status: 'error',
                title: 'Error al actualizar usuario. Vuelve a intentarlo.',
              });
            }
          }
        )
        .finally(() => setIsLoading(false));
    } else {
      toast.dismiss();
      getToast({
        status: 'error',
        title: 'Contraseñas no coinciden. Vuelve a intentarlo.',
      });
      setIsLoading(false);
    }
  };

  return (
    <Modal
      onEntering={resetFormFields}
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar usuario
        </Modal.Title>
      </Modal.Header>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={moment.locale()}
      >
        <Modal.Body>
          <form id="update-users-form" onSubmit={updateUser}>
            <div className="row">
              <div className="col-md-12">
                <TextField
                  sx={{ width: '100%' }}
                  label="Correo electrónico"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-6">
                <TextField
                  sx={{ width: '100%' }}
                  label="Nombre(s)"
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  sx={{ width: '100%' }}
                  label="Apellido(s)"
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
            <br />

            <div className="row">
              <div className="col-md-6">
                <TextField
                  sx={{ width: '100%' }}
                  label={jobString}
                  type="text"
                  value={job}
                  onChange={(e) => setJob(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <DatePicker
                  sx={{ width: '100%' }}
                  label={techEntryDateString}
                  type="date"
                  value={entryDate}
                  onChange={(newDate) => {
                    setEntryDate(newDate);
                  }}
                />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-6">
                <TextField
                  sx={{ width: '100%' }}
                  label="Contraseña"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPW(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <VisibilityOutlinedIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  sx={{ width: '100%' }}
                  label="Repetir contraseña"
                  type={showPassword ? 'text' : 'password'}
                  value={verifyPassword}
                  onChange={(e) => setVPW(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <VisibilityOutlinedIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-12">
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <>
                    <Autocomplete
                      multiple
                      disabled={loggedUserId === updateUserId || isLoading}
                      filterSelectedOptions
                      options={clients}
                      getOptionLabel={(client) => client.business_name}
                      onChange={(event, newValue) => {
                        setSelectedClients(newValue); // Allow normal selection
                      }}
                      value={selectedClients}
                      getOptionDisabled={(option) => option.can_select === 0} // Prevent selecting unassigned clients
                      renderTags={(tagValue, getTagProps) =>
                        tagValue.map((option, index) => {
                          const { onDelete, ...tagProps } = getTagProps({
                            index,
                          });

                          return (
                            <div
                              key={option.id}
                              style={{
                                position: 'relative',
                                display: 'inline-flex',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                style={{
                                  padding: '5px 10px',
                                  borderRadius: '16px',
                                  backgroundColor: '#ebebeb',
                                  display: 'flex',
                                  alignItems: 'center',
                                  margin: '2px',
                                  fontSize: '14px',
                                }}
                              >
                                {option.business_name}
                                {option.can_select === 1 &&
                                loggedUserId !== updateUserId ? (
                                  <span
                                    // {...tagProps}
                                    onClick={onDelete}
                                    style={{
                                      marginLeft: '8px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    <CancelIcon
                                      sx={{ color: 'gray', fontSize: '18px' }}
                                    />
                                  </span>
                                ) : (
                                  <span style={{ marginLeft: '8px' }}>
                                    <CancelIcon
                                      sx={{
                                        color: 'lightgray',
                                        fontSize: '18px',
                                      }}
                                    />
                                  </span>
                                )}
                              </div>
                            </div>
                          );
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Plazas"
                          placeholder="Plazas..."
                        />
                      )}
                    />
                    {loggedUserId !== updateUserId ? (
                      <Typography variant="caption">
                        Solo se pueden asignar/eliminar las plazas que tengas
                        asignadas
                      </Typography>
                    ) : (
                      <Typography variant="caption">
                        No se pueden modificar tus propias plazas
                      </Typography>
                    )}
                  </>
                )}
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-12">
                <Autocomplete
                  sx={{ width: '100%' }}
                  disablePortal
                  includeInputInList={false}
                  options={rolesData}
                  value={selectedRole}
                  getOptionLabel={(option) => option?.role_name || ''}
                  isOptionEqualToValue={(option, value) =>
                    option?.id === value?.id
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Seleccionar rol..."
                      required
                    />
                  )}
                  onChange={(event, newValue) => {
                    setSelectedRole(newValue);
                    setRole(newValue?.id || '');
                  }}
                />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-12">
                <TextField
                  sx={{ width: '100%' }}
                  label={notesString}
                  type="text"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>
            </div>

            <br />

            <div className="row">
              <div className="col-md-12">
                <TextField
                  sx={{ width: '100%' }}
                  label="Razón de cambio"
                  type="text"
                  multiline
                  rows={4}
                  value={changeReason}
                  onChange={(e) => setChangeReason(e.target.value)}
                  required
                />
              </div>
            </div>
          </form>
        </Modal.Body>
      </LocalizationProvider>
      <Modal.Footer>
        <Button
          type="submit"
          form="update-users-form"
          className="update-modal-button"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size="2rem" />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUUpdate;
